import { render, staticRenderFns } from "./AchBankTransfer.vue?vue&type=template&id=6e90f025"
import script from "./AchBankTransfer.vue?vue&type=script&lang=js"
export * from "./AchBankTransfer.vue?vue&type=script&lang=js"
import style0 from "./AchBankTransfer.vue?vue&type=style&index=0&id=6e90f025&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports